import React from 'react';

import SaveBanner from '../SaveBanner';
import './styles.scss';

const MainBanner = () => (
  <section
    className="main-banner"
  >
    <h1 className="banner-title">
      Reactivate Your Membership
    </h1>
    <h4 className="banner-subtitle">
      Reactivate to Annual to instantly save money!
    </h4>
    <SaveBanner />
  </section>
);

MainBanner.displayName = 'MainBanner';

export default MainBanner;
